// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "flatpickr" + "_chunk." + "eeaf39f1" + ".min.js";
};